<template>
  <div class="myButton" @click="buttonFn">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'navigation',
  data () {
    return {

    }
  },
  methods: {
    buttonFn () {
      this.$emit('clickFn', '')
    }
  }
}
</script>
<style scoped lang="scss">
.myButton{
  height: 46px;
  line-height: 46px;
  background: linear-gradient(270deg, #F27BCD 0%, #6547DA 100%);
  border-radius: 26px;
  padding: 0 20px;
  display: inline-block;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  &:hover{
    box-shadow: 0px 2px 8px 0px #C5BAE8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Mybutton.vue